import {getPaddingsClassFromData} from "@/utils/utils";
import React from "react";
import HeaderDescriptionWithButton from "@/components/common/HeaderDescriptionWithButton";

export default function TextAndDescriptionWithButton({data}) {
	const paddings = getPaddingsClassFromData(data)
	const leftHeaderText = data?.leftSideContent?.header || ''
	const leftDescriptionText = data?.leftSideContent?.description || ''
	const rightText = data?.text || ''

	return (
		<div className={paddings}>
			<HeaderDescriptionWithButton
				header={leftHeaderText}
				description={leftDescriptionText}
				button={data?.button}
			/>
		</div>
	)
}